import BasePropertyView from 'BasePropertyView.js';
import fileAttachmentTemplate from 'properties/table/column-main-file-button-labels.ejs';
import util         from 'util/Util.js';

// PF-5745
import undoService from 'UndoService';
import textConstants from 'TextConstants';

class MainButtonLabelsView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.tagName = 'div';
        this.id = opts.el;
        this.colId = this.model.get('selectedRowId');

        this.events = {
            'change input[type=text]' : 'updateAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus'
        };

        if(this.colId){
            let factorykey=this.model.get('gridData')[this.colId].get('factoryKey');
            util.updateHelpDocumentationLink(factorykey);
        }
        this.template = fileAttachmentTemplate;

        return this;
    }

    get columnModel() {
        return this.model.get('gridData')[this.colId];
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = util.sanitizeHTML(ev.currentTarget.value, true, this.model.get(propName));
        const oldPropVal = this.columnModel.attributes[propName];

        this.columnModel.attributes[propName] = propVal;

        undoService.add({
            undo: () => {
                this.columnModel.attributes[propName] = oldPropVal;
                this.render();  
            },
            redo: () => {
                this.columnModel.attributes[propName] = propVal;
                this.render();  
            }
          }, textConstants.UNDO_MOVE);
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.delegateEvents();
        return this;
    }

}

export default MainButtonLabelsView;
